import { BaseRecord } from "@refinedev/core";

export enum ReceivingStatus {
  DRAFT = "DRAFT",
  SUBMITTED_RECEIVED = "SUBMITTED_RECEIVED",
  RECEIVED = "RECEIVED",
  DRAFT_ACCEPTANCE = "DRAFT_ACCEPTANCE",
  SUBMITTED_ACCEPTANCE = "SUBMITTED_ACCEPTANCE",
  ACCEPTED = "ACCEPTED",
  PARTIAL_ACCEPTED = "PARTIAL_ACCEPTED",
  REJECTED = "REJECTED",
}

export enum ApprovalType {
  LOCAL = "LOCAL",
  EXTERNAL = "EXTERNAL",
}

export enum ApprovalStepStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}

export interface VendorInfo {
  vendorId: string;
  companyName: string;
  contactPerson?: string;
  email?: string;
  phone?: string;
  address?: string;
  tin?: string;
}

export interface ReceivingItem {
  id: string;
  name: string;
  description?: string;
  orderedQty: number;
  receivedQty: number;
  acceptedQty: number;
  rejectedQty: number;
  unit?: string;
  unitPrice?: number;
  remarks?: string;
  sourceOrderItemId?: string;
  tags?: string[];
}

export interface Attachment {
  fileId: string;
  originalName: string;
  mimeType: string;
  size: number;
  category?: string;
}

export interface ApprovalStep {
  order: number;
  roleSlug: string;
  stepName?: string;
  approvedBy?: string;
  approvedOn?: Date;
  remarks?: string;
  stepStatus: ApprovalStepStatus;
}

export interface Receiving extends BaseRecord {
  id: string;
  receivingNo: string;
  poId: string;
  poNo?: string;
  deliveryDate: Date;
  expectedDeliveryDate?: Date;
  vendorInfo: VendorInfo;
  items: ReceivingItem[];
  status: ReceivingStatus;
  attachments?: Attachment[];
  notes?: string;
  deliveryNotes?: string;
  qualityCheckBy?: string;
  qualityCheckDate?: Date;
  qualityCheckResult?: string;
  totalReceivedValue?: number;
  totalAcceptedValue?: number;
  tags?: string[];
  submittedBy?: string;
  approvedBy?: string;
  approvedAt?: Date;
  flowCaseId?: string;
  flowCaseNumber?: string;
  approvalType?: ApprovalType;
  steps?: ApprovalStep[];
  externalWorkflow?: Record<string, any>;
  acceptanceApprovalType?: ApprovalType;
  acceptanceExternalWorkflow?: Record<string, any>;
  acceptanceFlowCaseId?: string;
  acceptanceFlowCaseNumber?: string;
  receivingTemplateId?: string;
  acceptanceTemplateId?: string;
  createdAt: Date;
  updatedAt: Date;
  createdBy?: string;
  updatedBy?: string;
}

export interface CreateReceivingInput {
  poId: string;
  poNo?: string;
  deliveryDate: Date;
  expectedDeliveryDate?: Date;
  vendorInfo: VendorInfo;
  items: ReceivingItem[];
  attachments?: Attachment[];
  notes?: string;
  deliveryNotes?: string;
  tags?: string[];
}

export interface UpdateReceivingInput {
   poId?: string;
   poNo?: string;
   deliveryDate?: Date;
   expectedDeliveryDate?: Date;
   vendorInfo?: VendorInfo;
   items?: ReceivingItem[];
   attachments?: Attachment[];
   notes?: string;
   deliveryNotes?: string;
   receivedBy?: string;
   tags?: string[];
   status?: ReceivingStatus;
   inspectionDate?: Date;
   acceptedBy?: string;
   acceptedDate?: Date;
   inspectionNotes?: string;
 }

export interface SubmitReceivingInput {
  receivingId?: string;
  receivingData?: CreateReceivingInput;
  fiscalYear?: number;
}

export interface QualityCheckInput {
  receivingId: string;
  qualityCheckResult: string;
  remarks?: string;
}

export interface ReceivingApprovalInput {
  receivingId: string;
  action: string; // 'APPROVE' or 'REJECT'
  remarks?: string;
}